"use client"

import { useState } from "react"
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs"
import { ExpenseDashboard } from "@/components/expense-dashboard"
import { NewExpenseForm } from "@/components/new-expense-form"
import { ExpenseCategories } from "@/components/expense-categories"
import { ExpenseBudget } from "@/components/expense-budget"
import { ExpenseAnalytics } from "@/components/expense-analytics"

export default function ExpenseManagementPage() {
  const [activeTab, setActiveTab] = useState("dashboard")
  const [refreshKey, setRefreshKey] = useState(0)

  const handleExpenseAdded = () => {
    setRefreshKey(prevKey => prevKey + 1)
    setActiveTab("dashboard") // Switch to dashboard to see the new expense
  }

  return (
    <div className="flex-1 space-y-4 p-4 md:p-8 pt-6 bg-gray-50/50">
      <div className="flex items-center justify-between space-y-2">
        <h2 className="text-3xl font-bold tracking-tight text-gray-800">Expense Management</h2>
            </div>
      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="grid w-full grid-cols-5">
          <TabsTrigger value="dashboard">Dashboard</TabsTrigger>
          <TabsTrigger value="new-expense">New Expense</TabsTrigger>
          <TabsTrigger value="categories">Categories</TabsTrigger>
          <TabsTrigger value="budget">Budget</TabsTrigger>
          <TabsTrigger value="analytics">Analytics</TabsTrigger>
        </TabsList>
        <TabsContent value="dashboard">
          <ExpenseDashboard key={refreshKey} />
        </TabsContent>
        <TabsContent value="new-expense">
          <NewExpenseForm onExpenseAdded={handleExpenseAdded} />
        </TabsContent>
        <TabsContent value="categories">
          <ExpenseCategories key={refreshKey} />
        </TabsContent>
        <TabsContent value="budget">
          <ExpenseBudget />
        </TabsContent>
        <TabsContent value="analytics">
          <ExpenseAnalytics />
        </TabsContent>
      </Tabs>
    </div>
  )
} 